/** @format */
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Button,
  Form,
  Modal,
  Badge,
  CloseButton,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../../components/Card";

// Share-offcanvas
import SearchModal from "../../../../components/search-modal";
import { useGetJobAll } from "../../../../api/queries/job.query";
import { useGetCompanyByID } from "../../../../api/queries/company.query";
import {
  useCreateActivity,
  useCreateApplicationByJobID,
} from "../../../../api/mutations/application.mutation";
import background from "src/assets/images/9926.jpg";
import ProfileHeader from "./profile-header";
import JobApplicationModal from "./job-application-modal";
import SuccessModal from "./success-model";
import defaultCompPic from "src/assets/images/buildings.png";

const Jobs = () => {
  const [loadContent, setLoadContent] = useState(true);
  const [selectedJob, setSelectedJob] = useState(null);
  const [companyId, setCompanyId] = useState(null);

  useEffect(() => {
    function handleScroll() {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        setTimeout(() => {
          setLoadContent(false);
        }, 2000);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const { data: JobData, isLoading: isLoadingJobData } = useGetJobAll({
    select: (response) => response.data.jobs,
  });
  console.log(JobData);

  const { data: CompanyData, isLoading: isLoadingCompanyData } =
    useGetCompanyByID({
      select: (response) => response.data.company,
      enabled: !!companyId,
      params: {
        company_id: companyId,
      },
    });

  const handleJobSelect = (job) => {
    setSelectedJob(job);
    setCompanyId(job.company_id);
  };

  return (
    <>
      <div
        id="content-page"
        className="content-inner ml-8"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <br></br>

        <Container>
          <Row className="gx-4">
            <Col lg={4}>
              <Card className="w-100">
                <Dropdown
                  bsPrefix=" "
                  className=" position-relative d-none d-lg-block w-100"
                >
                  <Dropdown.Toggle
                    as="form"
                    bsPrefix=" "
                    action="#"
                    className=" w-100"
                  >
                    <Link className="" to="#"></Link>
                    <Form.Control
                      type="text"
                      className="text  form-control w-100 bg-white"
                      placeholder="Search for people or groups..."
                    />
                  </Dropdown.Toggle>
                  <SearchModal />
                </Dropdown>

                <Button className="mt-4 w-100 bg-success">Search Jobs</Button>
              </Card>
              <h3>Recommended Jobs For You</h3>
              {isLoadingJobData ? (
                <h2>Loading...</h2>
              ) : JobData && JobData.length > 0 ? (
                JobData.map((job) => (
                  <Card
                    key={job?.id}
                    className="card-block card-stretch w-100 mt-2 job-card"
                    style={{
                      cursor: "pointer",
                      borderColor: "slategray",
                      backgroundColor: "#f0f0f0",
                    }}
                  >
                    <Link
                      onClick={() => handleJobSelect(job)}
                      className="text-decoration-none"
                    >
                      <Card.Body>
                        <div className="d-flex align-items-center">
                          <div className="me-3">
                            <img
                              loading="lazy"
                              src={
                                job.company.logo.url
                                  ? job.company.logo.url
                                  : defaultCompPic
                              }
                              alt="profile-img"
                              className="img-fluid rounded-circle"
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                          <div>
                            <h4>{job.title}</h4>
                            <h6>{job.company.name}</h6>
                            <h6>{job.salary}</h6>
                            <p className="mb-2">{job.location}</p>
                          </div>
                        </div>
                      </Card.Body>
                    </Link>
                  </Card>
                ))
              ) : (
                <Card className="w-100 mt-2">
                  <Card.Body className="border border-slate-100 hover:border-slate-400 hover:bg-blue-100 position-relative z-3">
                    <h3>No jobs found</h3>
                  </Card.Body>
                </Card>
              )}
            </Col>
            <Col lg={8}>
              <div id="content">
                <Row className="special-post-container">
                  <Col sm={12}>
                    <JobDetail selectedJob={selectedJob} />{" "}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

const JobDetail = ({ selectedJob }) => {
  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showDescription, setShowDescription] = useState(false);
  const [files, setFiles] = useState([]);
  const [resumes, setResumes] = useState([]);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const handleShowSuccessModal = () => setShowSuccessModal(true);
  const handleCloseSuccessModal = () => setShowSuccessModal(false);

  // Handle file selection
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validFiles = selectedFiles.filter((file) => {
      // Allow only PDF and DOC/DOCX files
      return (
        file.type === "application/pdf" || // PDF files
        file.type === "application/msword" || // DOC files
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // DOCX files
      );
    });
    setFiles([selectedFiles]);
    console.log(files);
  };

  // Handle resume selection
  const handleResumeChange = (e) => {
    const selectedResumes = Array.from(e.target.files);
    const validFiles = selectedResumes.filter((file) => {
      // Allow only PDF and DOC/DOCX files
      return (
        file.type === "application/pdf" || // PDF files
        file.type === "application/msword" || // DOC files
        file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // DOCX files
      );
    });
    setResumes([selectedResumes]);
    console.log(resumes);
  };

  // API request to create activity
  const createActivityMutation = useCreateActivity({
    onSuccess: (data) => {
      console.log("Activity created:", data.data.id);

      createApplicationMutation.mutate({
        answer: "",
        activity_id: data.data.id || "",
        resumes: files,
        other_files: resumes,
        job_id: selectedJob?.id || "",
      });
    },
    onError: (error) => {
      console.error("Error creating activity:", error);
      setError("Error creating activity. Please try again.");
      setLoading(false);
    },
  });

  // API request to create application
  const createApplicationMutation = useCreateApplicationByJobID({
    params: {
      job_id: selectedJob?.id ?? "",
    },
    onSuccess: (data) => {
      console.log("Application created successfully:", data);
      setLoading(false);
      handleCloseModal();
      handleShowSuccessModal();
    },
    onError: (error) => {
      console.error("Error creating application:", error);
      setError("Error creating application. Please try again.");
      setLoading(false);
    },
  });

  // Apply job
  const handleApplyToJob = () => {
    if (!selectedJob) {
      setError("No job selected!");
      return;
    }

    setLoading(true);
    setError(null);

    createActivityMutation.mutate({
      name: `Application for ${selectedJob.title}`,
    });
  };

  // Show job description when applying
  const toggleDescription = () => {
    setShowDescription(!showDescription);
  };

  if (!selectedJob) {
    return <p>No job selected. Please select a job to view details.</p>;
  }

  return (
    <Card>
      <ProfileHeader
        selectedJob={selectedJob}
        loading={loading}
        handleOpenModal={handleOpenModal}
      />
      {/* 
      <JobApplicationModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        toggleDescription={toggleDescription}
        showDescription={showDescription}
        selectedJob={selectedJob}
        handleResumeChange={handleResumeChange}
        handleFileChange={handleFileChange}
        error={error}
        handleApplyToJob={handleApplyToJob}
        loading={loading}
      /> */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <div className="text-end">
          <CloseButton className="p-3" onClick={handleCloseModal} />
        </div>
        <div className="px-4">
          <Badge
            className="bg-primary"
            style={{ fontSize: "1.25rem", padding: "0.5rem 1rem" }}
          >
            Application
          </Badge>
        </div>
        <Modal.Header>
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex align-items-center">
              {/* Company logo */}
              <img
                loading="lazy"
                src={selectedJob?.company.logo.url || defaultCompPic}
                alt="company-logo"
                className="avatar-130 img-fluid me-3"
              />
              <div>
                {/* Job title and company */}
                <h4 className="fs-4 fw-bold">
                  {selectedJob?.title || "Full Stack Developer"}
                </h4>
                <p className="text-muted">
                  {selectedJob?.company?.name || "First Pavilion Global Berhad"}
                </p>
              </div>
            </div>
            {/* View Job Description button */}
            <div className="my-auto">
              <Button variant="outline-primary" onClick={toggleDescription}>
                View Job Description
              </Button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div>
            {showDescription && (
              <div className="mt-3">
                <h4>Job Description</h4>
                <p>{selectedJob?.description || "No description available"}</p>
              </div>
            )}
          </div>

          {/* Resume section */}
          <div className="mb-3">
            <h6>Resume</h6>
            <select className="form-select mb-2">
              <option>Select a resume to apply for this job</option>
              {/* Add dynamic options for resumes here */}
            </select>
            <div className="d-flex align-items-center">
              <input
                type="file"
                className="form-control"
                id="resumeUpload"
                onChange={handleResumeChange}
              />
              <Button className="ms-2" variant="outline-success">
                Upload
              </Button>
            </div>
          </div>

          {/* Cover letter section */}
          <div className="mb-3 d-flex align-items-center">
            <div className="flex-grow-1">
              <h6>Cover Letter</h6>
              <input
                type="file"
                className="form-control"
                placeholder="Please upload your cover letter"
                onChange={handleFileChange}
              />
            </div>
            <Button className="ms-2" variant="outline-success">
              Upload
            </Button>
          </div>

          {/* Error message if any */}
          {error && <p className="text-danger">{error}</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button
            variant="success"
            onClick={handleApplyToJob}
            disabled={loading}
          >
            {loading ? "Applying..." : "Apply"}
          </Button>
        </Modal.Footer>
      </Modal>

      <SuccessModal
        show={showSuccessModal}
        handleClose={handleCloseSuccessModal}
        selectedJob={selectedJob}
      />
    </Card>
  );
};

export default Jobs;
